export default __webpack_public_path__ + "static/media/collaborationImg.4b7a82bf.webp";